import React from 'react';

/*
  Parameters:
    size: String (whitespace separated size list i.e. "md" or "xs-6", "xs-6 md-4"). See bootstrap documentation for details
    className: String additional classes to be added to the col div
    ...rest: will be forwarded to the div
*/

const Col = ({children, size = 'xs-12', className, ...rest}) => {
  const sizeClasses = size.split(' ').map(s => `col-${s}`).join(' ');
  return <div className={`${sizeClasses} ${className ? ' ' + className : ''}`} {...rest}>
    {children}
  </div>
}

export default Col;